<template>
  <div>
    <div class="col-12 category_panel" v-for="(page, pageIdx) in listGroupPages">

      <div class="categoryPanelTitle">
        <div class="categoryEdito">
          <div class="row justify-content-center pb-5 pt-5 title_box">
            <div class="col-12"  v-if="sectionCount==1">
              <div class="subtitle_heading">{{categoryObject.title| translategrader($i18n.locale)}}</div>
            </div>
            <div class="col-8"  v-if="sectionCount>1">
              <div class="subtitle_heading">{{categoryObject.title| translategrader($i18n.locale)}}</div>
            </div>
            <div class="col-4"  v-if="sectionCount>1">
              <div class="progress">
                <div class="progress-bar"
                  role="progressbar"
                  :style="{ 'width': scorePercent+'%'}"
                  :class="{
                    'bg-success': isGood,
                    'bg-warning': isMedium,
                    'bg-error': isBad
                  }"
                  :aria-valuenow="scorePercent"
                  aria-valuemin="0"
                  aria-valuemax="100">{{scorePercent}}%
                </div>
              </div>
              <div class="w-100"></div>
              <div class="opinion"
                :class="{
                    'color-success': isGood,
                    'color-warning': isMedium,
                    'color-error': isBad
                  }">
                <span v-if="isGood">{{$t('front_end.result_mini_score_good')}}</span>
                <span v-if="isMedium">{{$t('front_end.result_mini_score_medium')}}</span>
                <span v-if="isBad">{{$t('front_end.result_mini_score_bad')}}</span>
              </div>
            </div>
          </div>
        </div> <!-- /categoryEdito -->
      </div> <!-- /categoryPanelTitle -->

      <div class="categoryBestPractice pb-5">
        <div
          class="row justify-content-between no-gutters"
          v-for="(question, idx) in categoryObject.questions.slice(currentCard + pageIdx*cardsPerPage , currentCard + (pageIdx+1)*cardsPerPage)">
          <div class="col-6">
            <answer-card-print
              :question = "question"
              :index = "idx+(currentCard + pageIdx*cardsPerPage)"
              :questionCount = "categoryObject.questions.length"
              :key = "idx"
              :isPrint = "true"
              :showBP = "false"
            ></answer-card-print>
          </div>
          <div class="col-6">
            <answer-card-print
              :question = "question"
              :index = "(currentCard + pageIdx*cardsPerPage)"
              :questionCount = "categoryObject.questions.length"
              :key = "idx"
              :isPrint = "true"
              :showBP = "true"
            ></answer-card-print>
          </div>
        </div>
      </div> <!-- /categoryBestPractice -->

    </div>
  </div>
</template>


<script>


import answerCardPrint from './answerCardPrint'

export default {
  name: 'renderPrintCardGroup',

  props: [
    'categoryObject',
    'sectionCount',
    'isGood',
    'isMedium',
    'isBad',
    'scorePercent',
    'cardsPerPage',
    'cardOffset'
  ],

  components: {
    answerCardPrint,
  },

  data () {
    return {
      numberofPages: 0,
      currentCard: 0,
      listGroupPages: []
    }
  },

  mounted: function() {
    this.numberofPages = Math.ceil( (this.categoryObject.questions.length - this.cardOffset) / this.cardsPerPage ) ;
    this.currentCard = this.cardOffset;
    this.listGroupPages = Array.from({length:this.numberofPages},(v,k)=>k+1);
  },

  methods: {

    incr: function(value) {
      value = value+1;
    }
  }

}

</script>

<style scoped>

.category_panel {
  /* background-color: #F3F4F5;*/
  margin-bottom: 60px;
  border-top: 5px solid var(--colorCategory);

  height: 361mm;
  size: A4;
}

@media print {
  .category_panel {
    page-break-before: always!important;
    background-color: #F3F4F5!important;
  }
}


.categoryEdito {
  padding: 0 12mm;
  font-family: 'Nunito', sans-serif;
  margin-bottom: 50px;
}
.categoryBestPractice {
  padding: 0 10mm;;
}

.title_box {
  position: relative;
  padding-bottom: 30px;
}

.title_box .subtitle_heading {

  text-align: left;
  color: var(--colorCategory);
  font-family: 'Nunito', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 30px;
  z-index: 999!important;
}

.title_box .current_page {
  margin-top: -65px;
  margin-bottom: -10px;
  text-align: center;
  color: var(--colorCategory);
  font-family: 'andale mono', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 60px;
  opacity: 0.5;
  z-index: 1!important;
}

.progress {
  border-radius: 20px;
  border: #dbdbdb 1px solid;
  height: 25px;
  background-color: #fff;
}

.bg-success {
  background-color: #139A43!important;
}
.bg-warning {
  background-color: #FC8F00!important;
}
.bg-error {
  background-color: #DC0000!important;
}

.color-success {
  color: #139A43!important;
}
.color-warning {
  color: #FC8F00!important;
}
.color-error {
  color: #DC0000!important;
}
.opinion {
  font-family: 'Nunito', sans-serif;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  padding-top: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/survey_results/renderPrintCardGroup.vue